"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationV1 = void 0;
var component_1 = require("./component");
var features_1 = require("./features");
var infrastructure_1 = require("./infrastructure");
var solutionConfiguration_1 = require("./solutionConfiguration");
var ConfigurationV1 = /** @class */ (function () {
    function ConfigurationV1(result) {
        var data = result.configData;
        this.configData = data;
        this.components = new component_1.ComponentsV1(data.components);
        this.features = new features_1.FeaturesV1(data.features);
        this.infrastructure = new infrastructure_1.InfrastructureV1(data.infrastructure);
        this.solutionConfiguration = new solutionConfiguration_1.SolutionConfigurationV1(data.solutionConfiguration);
        this.customerName = data.customerName;
        this.tenantId = result.tenantId;
        this.solutionType = data.solutionType;
        this.versionNumber = result.versionNumber;
        this.minCompatibleAppVersion = data.mobileClient.minCompatibleAppVersion;
        this.appUrls = data.mobileClient.appUrls;
        this.configRefreshCheckInterval = result.configRefreshCheckInterval;
    }
    ConfigurationV1.prototype.getComponents = function () {
        return this.components;
    };
    ConfigurationV1.prototype.getFeatures = function () {
        return this.features;
    };
    ConfigurationV1.prototype.getInfrastructure = function () {
        return this.infrastructure;
    };
    ConfigurationV1.prototype.getSolutionConfiguration = function () {
        return this.solutionConfiguration;
    };
    ConfigurationV1.prototype.getCustomerName = function () {
        return this.customerName;
    };
    ConfigurationV1.prototype.getTenantId = function () {
        return this.tenantId;
    };
    ConfigurationV1.prototype.getSolutionType = function () {
        return this.solutionType;
    };
    ConfigurationV1.prototype.getRawData = function () {
        return this.configData;
    };
    ConfigurationV1.prototype.getVersionNumber = function () {
        return this.versionNumber;
    };
    ConfigurationV1.prototype.getMinCompatibleAppVersion = function () {
        return this.minCompatibleAppVersion;
    };
    ConfigurationV1.prototype.getAppUrls = function () {
        return this.appUrls;
    };
    ConfigurationV1.prototype.getConfigRefreshCheckInterval = function () {
        return this.configRefreshCheckInterval;
    };
    return ConfigurationV1;
}());
exports.ConfigurationV1 = ConfigurationV1;
//# sourceMappingURL=configuration.js.map